/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.EmailQueue {

    @Serenity.Decorators.registerClass()
    export class EmailQueueGrid extends NoboxEntityGrid<EmailQueueRow, any> {
        protected getColumnsKey() { return EmailQueueColumns.columnsKey; }
        protected getDialogType() { return EmailQueueDialog; }
        protected getIdProperty() { return EmailQueueRow.idProperty; }
        protected getLocalTextPrefix() { return EmailQueueRow.localTextPrefix; }
        protected getService() { return EmailQueueService.baseUrl; }
        protected getDeletePermission() { return EmailQueueRow.deletePermission; }
        protected getInsertPermission() { return EmailQueueRow.insertPermission; }
        protected getUpdatePermission() { return EmailQueueRow.updatePermission; }

        constructor(container: JQuery) {
            super(container);
        }

        protected updateInterface() {
            this.defaultSetting = this.getCurrentSettings();
            super.updateInterface();
            if (!Q.Authorization.hasPermission("Role:Admin") && !Q.Authorization.hasPermission("Role:Support")) {
                $(".quick-filters-bar").remove();
            }
        }
        protected getButtons(): Serenity.ToolButton[] {

            var buttons = super.getButtons();
            var $this = this;
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as EmailQueueListRequest;
            request.IsAll = 1;
            return true;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            //Q.first(columns, x => x.field == EmailQueueRow.Fields.AccountName).format =
            //    ctx => `<a href="javascript:;" class="account-link" data-id="${ctx.item.AccountId}">${Q.htmlEncode(ctx.value)}</a>`;
            //Q.first(columns, x => x.field == EmailQueueRow.Fields.TenantId).format =
            //    ctx => `<a href="javascript:;" class="tenant-link" data-id="${ctx.value}">${Q.htmlEncode(tenants[ctx.value].Nm)}</a>`;
            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("account-link")) {
                e.preventDefault();
                Q.notifySuccess("Success filter by account");
                var accountFilter = this.findQuickFilter(AllAccountCascadeLookupEditor,
                    EmailQueueRow.Fields.AccountId);
                accountFilter.set_value(target.attr("data-id"));
                this.refresh();
            }else if (target.hasClass("tenant-link")) {
                e.preventDefault();
                Q.notifySuccess("Success filter by tenant");
                var tenantFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    EmailQueueRow.Fields.TenantId);
                tenantFilter.set_value(target.attr("data-id"));
                this.refresh();
            }
        }
    }
}